import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ToastComponent} from '../../shared/components/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  duration = 2000;

  constructor(private snackBar: MatSnackBar) {
  }

  publish(name: string, options: { type: 'success' | 'error' | 'info' } = {type: 'info'}): void {
    this.snackBar.dismiss();
    this.snackBar.openFromComponent(ToastComponent, {
      data: {
        text: name,
        type: options.type
      },
      duration: this.duration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: ['ostso-snackbar']
    });
  }

  open(name: string, options: { type: 'success' | 'error' | 'info' } = {type: 'info'}): void {
    this.snackBar.dismiss();
    this.snackBar.open(name, '', {
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: this.duration,
      panelClass: ['ostso-snackbar']
    });
  }

  start(name: string, options: { type: 'success' | 'error' | 'info' } = {type: 'info'}):void{
    this.snackBar.openFromComponent(ToastComponent, {
      data: {
        text: name,
        type: options.type
      },
      duration: this.duration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: ['ostso-snackbar']
    });
  }

  sucess(name: string):void{
    this.start(name, {type:'success'});
  }
  info(name: string):void{
    this.start(name, {type:'info'});
  }
  error(name: string):void{
    this.start(name, {type:'error'});
  }
}
